import {useLingui} from '@lingui/react/macro';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'extensions/navigation';
import {useToast} from 'react-native-toast-notifications';
import {useModal} from 'extensions/viewport/useModal';
import {Prompt} from 'interface/base/Prompt';
import {archive, loadTrash} from 'utils/mediafire';

export function useModalTrash(ids: string[]) {
  const {t} = useLingui();
  const modal = useModal();
  const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const submit = useCallback(async () => {
    const res = await archive(dispatch, ids);
    loadTrash(navigate, dispatch, true);
    if (res[0] || res[1]) {
      toast.show(`Moved items to trash`);
    } else {
      toast.show(res?.message ?? t`Failed to move items to trash`, {type: 'danger'});
    }
    modal.exit();
  }, [ids]);

  const open = useCallback(() => {
    modal.open(
      <Prompt
        title={t`Move to Trash`}
        text={t`Are you sure you want to move these items to Trash? You can always restore items from your trash if you change your mind.`}
        buttons={[
          {
            mode: 'destructive',
            text: t`Move to Trash`.toUpperCase(),
            onPress: submit,
          },
          {
            mode: 'cancel',
            text: t`Cancel`.toUpperCase(),
            onPress: modal.exit,
          },
        ]}
      />
    );
  }, [ids]);

  return {open, exit: modal.exit};
}
